import {createSlice} from '@reduxjs/toolkit';

import ModalTypes from '@/consts/app/modalTypes';

const initialState = {
    popups: {
        [ModalTypes.EARN_BADGE]: {
            state: {
                isPending: false,
                isVisible: false,
                props: undefined,
            },
        },
        [ModalTypes.COMPLETE_JOURNEY_LEVEL_TASK]: {
            ignoreIf: [ModalTypes.EARN_BADGE],
            state: {
                isPending: false,
                isVisible: false,
                props: undefined,
            },
        },
    },
};

export const slice = createSlice({
    name: 'loyalty',
    initialState,
    reducers: {
        setJourneyBadgePending: (state, action) => {
            state.popups[ModalTypes.EARN_BADGE].state.isPending = action.payload;

            return state;
        },
        setJourneyLevelTaskPending: (state, action) => {
            state.popups[ModalTypes.COMPLETE_JOURNEY_LEVEL_TASK].state.isPending = action.payload;

            return state;
        },
        setJourneyBadgePopupState: (state, action) => {
            state.popups[ModalTypes.EARN_BADGE].state = action.payload;

            return state;
        },
        setJourneyLevelTaskPopupState: (state, action) => {
            state.popups[ModalTypes.COMPLETE_JOURNEY_LEVEL_TASK].state = action.payload;

            return state;
        },
        resetLoyaltyPopup: (state, action) => {
            const popupKey = action.payload;

            if (state.popups[popupKey]) {
                state.popups[popupKey].state = {isVisible: false, props: undefined};
            }
            return state;
        },
    },
});

export const {
    setJourneyBadgePending,
    setJourneyLevelTaskPending,
    setJourneyBadgePopupState,
    setJourneyLevelTaskPopupState,
    resetLoyaltyPopup,
} = slice.actions;

export default slice.reducer;
